import { IEventRequestParams } from './shared.dto';
import { CustomPageConfigurationType, EventParams } from './custom-pages.dao';
import { JobDtoType } from '../domain/jobs';

abstract class IWebsiteDAO {
    public abstract getReservedSubDomainArray(): Promise<string[]>;
    public abstract getAllPagesConfiguration(params: EventParams): Promise<IAllPagesConfigurationDTO>;
    public abstract updateAllPagesConfiguration(params: EventParams, updateParams: IAllPagesConfigurationDTO): Promise<IAllPagesConfigurationDTO>;
    public abstract updateWebsiteShowcase(params: IEventRequestParams, showcaseParams: IUpdateShowcaseDTO): Promise<IUpdateShowcaseDTO>;
    public abstract updateEmailAddressDisplayName(params: IEventRequestParams & IEmailAddressDisplayNameDTO): Promise<void>;
    public abstract downloadConfigurationJSON(params: IEventRequestParams): Promise<void>;
    public abstract uploadConfigurationJSON(params: IEventRequestParams & { file: File }): Promise<JobDtoType>;
    public abstract updateMeetingLinksLabel(params: IEventRequestParams & IMeetingLinksLabelDTO): Promise<void>;
}

interface IUpdateShowcaseDTO {
    embedCodeId: string;
    showcaseLabel: string;
    showcaseLinkDescription: string;
}

interface IAllPagesConfigurationDTO {
    pages: CustomPageConfigurationType[];
}

enum MagicLinkValidityPeriodStrategy {
    CURRENT_DATE = 'CURRENT_DATE',
    EVENT_END_DATE = 'EVENT_END_DATE'
}

interface IEmailAddressDisplayNameDTO{
    emailDisplayName: string;
}

interface IMeetingLinksLabelDTO{
    meetingLinksLabel: string;
}

export {
    IAllPagesConfigurationDTO,
    IWebsiteDAO,
    IUpdateShowcaseDTO,
    MagicLinkValidityPeriodStrategy,
    IEmailAddressDisplayNameDTO,
    IMeetingLinksLabelDTO,
};
